import * as React from "react";
import "./style_1.scss";
import TextWithLinksParser from "../../TextWithLinksParser/TextWithLinksParser";
import { CustomMap } from "../../CustomMap";

export default function ProductAccordionContentStyle1({
  infoBlock,
  itemIndex,
}) {
  const transportAvailableIcons = [
    "air",
    "ocean",
    "road",
    "train",
    "ocean_air",
    "rail_road",
    "road_air",
  ];
  return (
    <div
      className={`accordion-content-block style_1 ${
        itemIndex % 2 === 0 ? "is-even" : "is-odd"
      }`}
    >
      <CustomMap infoBlock={infoBlock.presentation.info} />

      {infoBlock.presentation ? (
        <>
          <div className={`product-item-presentation`}>
            <div className={`product-item-image`}>
              <img src={infoBlock.presentation.image} alt="" />
            </div>
            <h4>
              <span>{infoBlock.title}</span>
            </h4>
          </div>

          {infoBlock.presentation && infoBlock.presentation.info && (
            <div className={`product-item-info`}>
              {infoBlock.presentation.info
                .filter(
                  (item) => item.key.toLowerCase() !== "factory certification"
                )
                .map((presentationItem) =>
                  presentationItem.label &&
                  presentationItem.label.length > 0 ? (
                    <div
                      className={`product-item-info-item`}
                      key={presentationItem.key}
                    >
                      <h5>{presentationItem.key}:</h5>
                      <h6>
                        <span>{presentationItem.label}</span>
                      </h6>
                    </div>
                  ) : null
                )}
            </div>
          )}

          <div className={`location-info-image`}>
            {infoBlock.transport &&
              transportAvailableIcons.includes(infoBlock.transport) && (
                <i className={`location-footprint ${infoBlock.transport}`}>
                  <img
                    src={`/static/images/icons/footprint/${infoBlock.transport}.png`}
                    alt=""
                  />
                </i>
              )}
            <i className={"location-path"}></i>
          </div>
        </>
      ) : (
        <div className={`product-item-presentation`}>
          <h4>
            <span>{infoBlock.title}</span>
          </h4>
        </div>
      )}

      <div className={`product-item-description`}>
        <div className={`product-item-description-text`}>
          <p>
            <TextWithLinksParser text={infoBlock.description} />
          </p>
        </div>
        {infoBlock.presentation && infoBlock.presentation.info && (
          <>
            <div className={`product-item-info-audit`}>
              {infoBlock.presentation.info
                .filter(
                  (item) => item.key.toLowerCase() === "factory certification"
                )
                .map((presentationItem) =>
                  presentationItem.label &&
                  presentationItem.label.length > 0 &&
                  presentationItem.notification.length > 0 &&
                  presentationItem.key.length > 0 ? (
                    <div
                      className={`product-item-info-item-audit`}
                      key={presentationItem.key}
                    >
                      <div className={``}>
                        <h5>{presentationItem.key}:</h5>
                        <h6>
                          <span>{presentationItem.label}</span>
                        </h6>
                      </div>

                      {presentationItem.notification && (
                        <p className={`notification-text`}>
                          {presentationItem.notification}
                        </p>
                      )}
                    </div>
                  ) : null
                )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
